import type { StoreTagDTO } from '@gozoki/api-types'
import { Chip, Typography } from '@mui/material'

/** Longueur maximale d'un label de tag — appliquée à la création (front + Vine) et à l'affichage. */
export const TAG_LABEL_MAX_LENGTH = 12

export const truncateTagLabel = (label: string) =>
  label.length > TAG_LABEL_MAX_LENGTH ? `${label.slice(0, TAG_LABEL_MAX_LENGTH)}…` : label

/** Couleur des chips de tags : alternance vert primaire / orange secondaire. */
export const tagChipColor = (index: number): 'primary' | 'secondary' =>
  index % 2 === 0 ? 'primary' : 'secondary'

interface StoreTagChipsProps {
  tags?: StoreTagDTO[]
  /** Nombre maximum de tags affichés ; au-delà, un indicateur « +N » est ajouté. */
  max?: number
  size?: 'small' | 'medium'
}

export const StoreTagChips = ({ tags = [], max, size = 'medium' }: StoreTagChipsProps) => {
  if (tags.length === 0) return null
  const visible = max === undefined ? tags : tags.slice(0, max)
  const hiddenCount = tags.length - visible.length

  return (
    <div style={{ alignItems: 'center', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
      {visible.map((tag, index) => (
        <Chip
          key={tag.id}
          size={size}
          color={tagChipColor(index)}
          label={truncateTagLabel(tag.label)}
        />
      ))}
      {hiddenCount > 0 && (
        <Typography
          variant="caption"
          color="text.secondary"
          title={tags.map((t) => t.label).join(', ')}
        >
          +{hiddenCount}
        </Typography>
      )}
    </div>
  )
}
